import { format, parse, isPast} from 'date-fns';
import { useState } from 'react';
import { uk } from 'date-fns/locale';
import { Link, useNavigate } from "react-router-dom";

import "./order-button.css";
import { useSettings } from '../../../../app/context/settings-context/settings-context';
import { CartWarning } from '../../modal/location-modal/warning/cart-warning/cart-warning';


export const OrderButton = () => {

    const navigate = useNavigate();

    const {schedule} = useSettings();

    const [warning, setWarning] = useState(false);

    const isClose = () => {
        const now = new Date();

        const day = format(now, 'eeee', {locale: uk});

        const workHours = schedule().find(item => item.hasOwnProperty(day));

        const closeTime =  parse(workHours[day].end, 'HH:mm', new Date());

        if (!isPast(closeTime)) {
            return navigate(`/shipping`)
        } else {
            setWarning(isPast(closeTime));
        }  
    }

    return (
        <>
            <div className="order-nav-wrap" >
                <div className="container d-flex justify-content-end align-items-center">
                    <div className="order-button-wrap">
                        <div onClick={() => isClose()} className="order-button btn">Оформити</div>
                    </div>
                </div>
            </div>
            {warning &&
                <CartWarning/>
            }
        </>
    )
}